import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import QuizFinish from './components/QuizFinish'
import QuizInfo from './components/QuizInfo'
import QuizQuestion from './components/QuizQuestion'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { STAGE_TYPES } from './components/const'
import { ISetAswersProps } from './interfaces'
import { api } from '@/api'

const Quiz = (): React.ReactElement => {
  const [stage, setStage] = useState(STAGE_TYPES.start)
  const [userAnswers, setUserAnswers] = useState({})
  const [currentQuestion, setCurrentQuestion] = useState(1)
  const [questions, setQuestions] = useState({})

  const page = usePage()
  const { config } = page?.init_state?.global
  const { object } = page?.init_state
  const { data } = useSWR({ id: object.id }, api.getQuiz)

  const scrollingPage = (): void => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  useEffect(() => {
    const questions = {}
    data?.property_questions_value.forEach((el, index): void => {
      const correctAnswer = el?.property_correct_answers_value.trim() ?? ''
      const questionKey = Number(index) + 1
      questions[questionKey] = {
        name: el.name ?? '',
        preview_picture: el.preview_picture ?? [],
        property_answers_value: el.property_answers_value ?? [],
        property_correct_answers_value: correctAnswer
      }
    })
    setQuestions(questions)
  }, [data])

  useEffect(() => {
    scrollingPage()
  }, [currentQuestion, stage])

  const onClickStart = (): void => {
    setStage(STAGE_TYPES.process)
    setUserAnswers({})
    setCurrentQuestion(1)
  }

  const setAnswer = ({ answer, questionNumber }: ISetAswersProps): void => {
    const answersList = { ...userAnswers }
    const correctAnswer =
      questions[questionNumber].property_correct_answers_value
    const userAnswer = answer ?? ''
    answersList[questionNumber] = {
      correctAnswer,
      isAswerCorrect: correctAnswer === userAnswer,
      question: questions[questionNumber].name,
      userAnswer
    }
    setUserAnswers(answersList)
  }

  const onClickNext = (): void => {
    const questionsCount = Object.keys(questions).length
    if (currentQuestion === questionsCount) {
      setStage(STAGE_TYPES.finish)
    } else {
      setCurrentQuestion(currentQuestion + 1)
    }
  }

  const onClickBack = (): void => {
    setCurrentQuestion(currentQuestion - 1)
  }

  return (
    <>
      <Container>
        <BackLink href={config.live_like_a_host} title='Живи как хозяин' />
        <Title type='h1' hidden>
          {object.title}
        </Title>
      </Container>

      {stage === STAGE_TYPES.start
        ? (
          <QuizInfo
            onClickStart={onClickStart}
            detailText={data?.detail_text ?? ''}
            title={object?.title}
            image={data?.detail_picture}
          />
          )
        : null}

      {stage === STAGE_TYPES.process
        ? (
          <QuizQuestion
            key={`question-${currentQuestion}`}
            question={questions[currentQuestion]}
            questionsCount={Object.keys(questions).length}
            questionNumber={currentQuestion}
            title={object?.title}
            userAnswer={userAnswers[currentQuestion]?.userAnswer ?? ''}
            onClickNext={onClickNext}
            onClickBack={onClickBack}
            setAnswer={setAnswer}
          />
          )
        : null}

      {stage === STAGE_TYPES.finish
        ? (
          <QuizFinish
            title={object?.title}
            textCompletion={data?.property_text_completion_value?.TEXT}
            userAnswers={userAnswers}
            countQuestions={Object.keys(questions).length}
            onQuizStart={onClickStart}
          />
          )
        : null}
    </>
  )
}

export default Quiz
